// Функция для генерации или получения сохранённого device_id
export function getDeviceId(): string {
    let deviceId = localStorage.getItem('device_id');

    if (!deviceId) {
        // Генерируем UUID v4 (самый надёжный способ)
        deviceId = crypto.randomUUID?.() || generateUUIDv4(); // crypto.randomUUID() доступен в современных браузерах

        // Убираем дефисы, чтобы было короче и без "опасных" символов
        deviceId = deviceId.replace(/-/g, '');

        if (deviceId.length !== 32) {
            deviceId = generateUUIDv4().replace(/-/g, '');
        }

        // Сохраняем навсегда (пока пользователь не очистит localStorage)
        localStorage.setItem('device_id', deviceId);
    }

    return deviceId;
}

// Fallback-генератор UUID v4 (работает даже в старых браузерах)
function generateUUIDv4() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Полностью совместимая реализация по RFC 4122
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

